<template>
  <!-- Contenedor principal -->
  <v-container>
    <!-- Problema que resuelve Deltia -->
    <v-row class="fill-height" align="center">
      <!-- Copy -->
      <v-col cols="12" md="6">
        <!-- Fila para el texto -->
        <v-row>
          <v-col cols="12">
            <!-- Header -->
            <p class="display-1 font-weight-black">
              Manejar un negocio es complicado, Deltia lo hace más fácil.
            </p>
            <!-- Descripción -->
            <p class="title font-weight-regular mb-0">
              Deltia es una plataforma para administrar tus productos, ventas,
              inventario y más. Es fácil de usar para ti y para tu equipo.
            </p>
          </v-col>
        </v-row>
        <!-- Fila para el call to action -->
        <v-row>
          <v-col cols="12" md="10">
            <!-- Botón para registrarse -->
            <v-btn
              class="mb-5"
              color="primary"
              depressed
              rounded
              large
              @click="$router.push({ name: 'sign-up' })"
            >
              Comenzar
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <!-- Video -->
      <v-col cols="12" md="6">
        <vueVimeoPlayer
          :options="{ responsive: true }"
          style="width: 100%;"
          video-id="484309130"
        />
      </v-col>
      <!-- Botón para bajar -->
      <v-col cols="12" class="text-center">
        <v-icon x-large>mdi-chevron-down</v-icon>
      </v-col>
    </v-row>
    <!-- Beneficios -->
    <v-row justify="center">
      <!-- Beneficio 1 de Deltia -->
      <v-col cols="10" md="4" class="text-center">
        <!-- Imagen -->
        <v-img
          contain
          alt="Computadora"
          position="center"
          max-height="100"
          aspect-ratio="1"
          src="@/assets/periodic.png"
        />
        <!-- Título -->
        <p class="overline font-weight-bold mb-0">
          Aprovecha tu información
        </p>
        <!-- Descripción -->
        <p class="caption">
          Las gráficas en el panel de Deltia te permiten entender mejor tu
          negocio y tomar decisiones basadas en datos.
        </p>
      </v-col>
      <!-- Beneficio 2 de Deltia -->
      <v-col cols="10" md="4" class="text-center">
        <!-- Imagen -->
        <v-img
          contain
          alt="Computadora"
          position="center"
          max-height="100"
          aspect-ratio="1"
          src="@/assets/pos.png"
        />
        <!-- Título -->
        <p class="overline font-weight-bold mb-0">
          Registra tu operación diaria
        </p>
        <!-- Descripción -->
        <p class="caption">
          La intuitiva interfaz de Deltia te ayuda a registrar fácilmente tus
          ventas, ingresos y egresos.
        </p>
      </v-col>
      <!-- Beneficio 3 de Deltia -->
      <v-col cols="10" md="4" class="text-center">
        <!-- Imagen -->
        <v-img
          contain
          alt="Computadora"
          position="center"
          max-height="100"
          aspect-ratio="1"
          src="@/assets/shelf.png"
        />
        <!-- Título -->
        <p class="overline font-weight-bold mb-0">
          Maneja tu inventario
        </p>
        <!-- Descripción -->
        <p class="caption">
          Deltia te permite registrar tus productos, sucursales y así manejar de
          forma sencilla el inventario de tu negocio.
        </p>
      </v-col>
      <!-- Botón para bajar -->
      <v-col cols="12" class="text-center">
        <v-icon x-large>mdi-chevron-down</v-icon>
      </v-col>
    </v-row>
    <!-- Usa Deltia con tu equipo -->
    <v-row align="center">
      <!-- Imagen -->
      <v-col align="center" cols="12" md="6">
        <v-img
          src="https://deltia-production.s3.amazonaws.com/static/platform.png"
          max-width="70vw"
          position="center"
          contain
        />
      </v-col>
      <!-- Texto -->
      <v-col cols="12" md="6">
        <!-- Header -->
        <p class="display-1 font-weight-black">
          Usa Deltia con tu equipo
        </p>
        <!-- Descripción -->
        <p class="title font-weight-regular mb-0">
          Puedes darle acceso a Deltia a tus empleados, así podrán registrar
          ventas, ingresos y egresos desde cualquier lugar, sólo necesitan un
          dispositivo con acceso a internet.
        </p>
      </v-col>
      <!-- Botón para bajar -->
      <v-col cols="12" class="text-center">
        <v-icon x-large>mdi-chevron-down</v-icon>
      </v-col>
    </v-row>
    <!-- Regístrate -->
    <v-row justify="center" class="text-center">
      <v-col cols="12" md="12">
        <!-- Botón para registrarse -->
        <v-btn
          class="mb-5"
          color="primary"
          depressed
          rounded
          large
          @click="$router.push({ name: 'sign-up' })"
        >
          Regístrate
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Importar componentes
import { vueVimeoPlayer } from "vue-vimeo-player";

export default {
  name: "Home",
  components: {
    vueVimeoPlayer
  }
};
</script>
